var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.996094 14.3318H15.0031M0.996094 14.3318V11.0818L7.99962 4.58185M0.996094 14.3318H4.49785L11.5014 7.83184M7.99962 4.58185L10.5109 2.25107L10.5125 2.24968C10.8581 1.92884 11.0313 1.76814 11.2309 1.70795C11.4067 1.65493 11.5961 1.65493 11.772 1.70795C11.9714 1.7681 12.1444 1.92862 12.4896 2.249L14.0127 3.66259C14.3593 3.98436 14.5328 4.14531 14.5977 4.33083C14.6549 4.49401 14.6548 4.66979 14.5977 4.83298C14.5328 5.01836 14.3597 5.17907 14.0135 5.50038L14.0127 5.50107L11.5014 7.83184M7.99962 4.58185L11.5014 7.83184",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.156f2673e305fbb647f62e2050632875.svg";
export { ForwardRef as ReactComponent };